(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    const NAV_ARROWS = 'arrows';
    
    customElements.define('announcement-bar-slideshow', class extends Core {
        elements = {
            swiper: '[data-swiper]',
            next: '[data-next]',
            prev: '[data-prev]'
        }

        render() {
            this._setSwiperProps();
            this._initSwiper();
        }

        _setSwiperProps() {
            // Loop mode and autoplay intentionally disabled here too, same
            // reasoning as slideshow-hero.js: the combination of loop's
            // continuous slide-cloning and autoplay's periodic transitions was
            // producing a repeating DOM mutation + layout/paint cascade for as
            // long as the page stayed open.
            this.swiperProps = {
                loop: false,
            };
            
            if(this.arrows)
                this.swiperProps.navigation = {
                    nextEl: this.$next,
                    prevEl: this.$prev
                }
        }
 
        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, this.swiperProps);
        }

        get arrows() {
            return this.hasAttribute(NAV_ARROWS);
        }
    })
})();